import { Controller } from "@hotwired/stimulus"

// The place-token treatment for a plain <select>: once something is chosen the dropdown is
// replaced by the same green token, and the pencil brings the dropdown back. No lookup and
// nothing to verify - choosing from a fixed list is its own confirmation - so this is markup
// and visibility only, deliberately not a second copy of place_token_controller.
export default class extends Controller {
  static targets = ["select", "token", "tokenPrimary", "edit"]

  connect() {
    this.onChange = this.onChange.bind(this)
    this.selectTarget.addEventListener("change", this.onChange)
    // A cloned row (Add A Brand) carries the source row's token markup with no state behind it;
    // the select's own value is the only thing worth trusting.
    this.render()
  }

  disconnect() {
    this.selectTarget.removeEventListener("change", this.onChange)
  }

  onChange() {
    this.render()
  }

  // Hands the dropdown back and opens it, so choosing again is one gesture rather than two.
  edit() {
    this.render(true)
    this.selectTarget.focus()
    // Progressive enhancement only: showPicker throws without a user gesture and is not everywhere.
    // A focused dropdown the user has to click open is a fine outcome; a broken pencil is not.
    try {
      this.selectTarget.showPicker?.()
    } catch {
      // The dropdown is focused either way.
    }
  }

  render(editing = false) {
    const label = this.selectTarget.selectedOptions[0]?.text
    const chosen = Boolean(this.selectTarget.value) && !editing

    this.selectTarget.classList.toggle("d-none", chosen)
    this.tokenTarget.classList.toggle("d-none", !chosen)
    this.editTarget.classList.toggle("d-none", !chosen)
    if (chosen) this.tokenPrimaryTarget.textContent = label
  }
}
